import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
}
export function smoothScrollTo(targetId: string, duration: number = 1500) {
  const target = document.getElementById(targetId);
  if (!target) return;
  const start = window.scrollY;
  const targetPosition = target.getBoundingClientRect().top;
  const end = targetPosition + start;
  const distance = end - start;
  let startTime: number | null = null;
  function easeInOutCubic(t: number) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
  function step(timestamp: number) {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    window.scrollTo(0, start + distance * easeInOutCubic(progress));
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }
  requestAnimationFrame(step);
}
export function CTAButton({
  text,
  className = '',
  onClick
}: CTAButtonProps) {
  const baseClasses = 'block w-full md:w-auto bg-[#8FF650] hover:bg-[#7DE040] text-black font-black text-xl md:text-2xl py-4 px-6 rounded-xl shadow-[0_0_25px_rgba(143,246,80,0.5)] hover:shadow-[0_0_35px_rgba(143,246,80,0.7)] text-center transition-all hover:scale-105 uppercase tracking-wide';
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    } else {
      smoothScrollTo('compra', 1500);
    }
  };
  return <button onClick={handleClick} className={`w-full md:w-auto ${className}`} data-id="element-91">
      <motion.div animate={{
      scale: [1, 1.02, 1]
    }} transition={{
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    }} className={baseClasses} data-id="element-92">
        {text}
      </motion.div>
    </button>;
}